/**
 * Created by Mateen on 5/6/2019.
 */

import { Injectable } from '@angular/core';
import * as RecordRTC from 'recordrtc';
import {Subject, Observable} from "rxjs";
// import moment = require("moment");
import * as moment from 'moment';

@Injectable()
export class AudioRecordingService {
    private stream;
    private recorder;
    private interval;
    private startTime;
    public file:any;
    private _recorded = new Subject<any>();
    private _recordingTime = new Subject<string>();
    private _recordingFailed = new Subject<string>();

    constructor() {
    }
    getRecordedBlob(): Observable<any> {
        return this._recorded.asObservable();
    }

    getRecordedTime(): Observable<string> {
        return this._recordingTime.asObservable();
    }

    recordingFailed(): Observable<string> {
        return this._recordingFailed.asObservable();
    }

    startRecording() {

        if (this.recorder) {
            // It means recording is already started or it is already recording something
            return;
        }

        this._recordingTime.next('00:00');
        navigator.mediaDevices.getUserMedia({ audio: true }).then(s => {
            this.stream = s;
            this.record();
        }).catch(error => {
            this._recordingFailed.next();
        });

    }

    private record() {

        this.recorder = new RecordRTC.StereoAudioRecorder(this.stream, {
            type: 'mp3',
            mimeType: 'audio/webm'
        });

        this.recorder.record();
        this.startTime = moment();
        this.interval = setInterval(
            () => {
                const currentTime = moment();
                const diffTime = moment.duration(currentTime.diff(this.startTime));
                const time = this.toString(diffTime.minutes()) + ':' + this.toString(diffTime.seconds());
                this._recordingTime.next(time);
            },
            1000
        );
    }
    private toString(value) {
        let val = value;
        if (!value) {
            val = '00';
        }
        if (value < 10) {
            val = '0' + value;
        }
        return val;
    }

    stopRecording() {

        if (this.recorder) {
            this.recorder.stop((blob) => {
                if (this.startTime) {
                    const mp3Name = encodeURIComponent('audio_' + new Date().getTime() + '.mp3');
                    this.stopMedia();
                    this._recorded.next({ blob: blob, title: mp3Name });
                    this.file = new File([blob], mp3Name, {type: "audio/mp3"});
                    console.log('FILEEEEE:: ',this.file);
                    /*var a:any = document.createElement("a");
                    document.body.appendChild(a);
                    a.style = "display: none";
                    // blob = new Blob([json], {type: "octet/stream"}),
                    var url = window.URL.createObjectURL(blob);
                    a.href = url;
                    a.download = mp3Name;
                    a.click();

                    window.URL.revokeObjectURL(url);
                    console.log(blob);*/
                }
            }, () => {
                this.stopMedia();
                this._recordingFailed.next();
            });
        }

    }
   blobToFile (theBlob: any, fileName:string): File{
        let b: any = theBlob;
        //A Blob() is almost a File() - it's just missing the two properties below which we will add
        b.lastModifiedDate = new Date();
        b.file_name = fileName;

        //Cast to a File() type
        return <File>theBlob;
    }

    private stopMedia() {
        if (this.recorder) {
            this.recorder = null;
            clearInterval(this.interval);
            this.startTime = null;
            if (this.stream) {
                this.stream.getAudioTracks().forEach(track => track.stop());
                this.stream = null;
            }
        }
    }


    //This function is used to release the resources.

    abortRecording() {
        this.stopMedia();
    }
}


// WEBPACK FOOTER //
// ./src/app/lib/AudioRecordingService.ts